export class AdditionalModel {
    static addtlConsent;
    static acmVersion;
    static molGvlVersion;
    static nrvString;
    static nrvVersion;
    static repromptVersion;
}
